import React, { FC } from 'react';
import { paymentAgreement } from '@apply/constants';
import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

export type AcknowledgementProps = {
    acknowledged: boolean;
    setAcknowledged: (acknowledged: boolean) => void;
    showLocTerms: boolean;
};

export const Acknowledgement: FC<AcknowledgementProps> = ({ acknowledged, setAcknowledged, showLocTerms }) => {
    const mobileScreen = isMobileScreen();
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAcknowledged(e.target.checked);
    };
    return (
        <div className='appraisal-section appraisal-acknowledgement-section'>
            <div
                className='title'
                style={{ marginTop: 40, marginBottom: 10 }}
            >
                Legal Acknowledgement
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', padding: mobileScreen ? 0 : 20 }}>
                <Panel
                    theme={PanelTheme.Gray}
                    borderStyle={PanelBorderStyle.Solid}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    <div className='payment-agreement'>
                        {showLocTerms && (
                            <>
                                I understand and agree to the following: Applicant is entitled to receive a copy of appraisal
                                report(s). For Line of Credit applications there are refunds. This charge is an estimate. If the
                                actual cost of appraisal report(s) and transaction costs (approximately 3% for credit cards) is
                                less, BFI will provide a refund. If the actual cost of appraisal report(s) and transaction costs
                                is more, BFI reserves the right to bill you. If this payment is used for a type of application
                                other than a Line of Credit, different rules apply and you will not be eligible for a refund.
                                Making this payment does not guaranty that BFI will order appraisal report(s). If BFI does not
                                order appraisal report(s), BFI will attempt to reverse the charges and/or provide a refund less
                                any transaction charges incurred.
                            </>
                        )}
                        {!showLocTerms && <>{paymentAgreement}</>}
                    </div>
                </Panel>
                <div className='acknowledgement'>
                    <input
                        type='checkbox'
                        id='appraisalAcknowledgement'
                        checked={acknowledged}
                        onChange={onChange}
                        style={{ cursor: 'pointer' }}
                    />
                    <label
                        htmlFor='appraisalAcknowledgement'
                        style={{ cursor: 'pointer' }}
                    >
                        I understand and agree
                    </label>
                </div>
            </div>
        </div>
    );
};
